import { useEffect, useId, useLayoutEffect, useRef, useState } from 'react';
import { foodBrandSuggestions } from '@jungles/shared';
import { api } from '../lib/api';

export function FoodBrandInput({value,onChange}: {value:string;onChange:(value:string)=>void}) {
  const id=useId();
  const listRef=useRef<HTMLUListElement>(null);
  const [brands,setBrands]=useState<string[]>([]);
  const [focused,setFocused]=useState(false);
  const [open,setOpen]=useState(false);
  const [active,setActive]=useState(-1);
  const [error,setError]=useState<string | null>(null);
  useEffect(()=>{
    setBrands([]);setActive(-1);setError(null);
    if(!focused || !value.trim()) return;
    const controller=new AbortController();
    const timer=setTimeout(()=>{
      void api.get<{brands:string[];error?:string | null}>(`/api/food-brands?q=${encodeURIComponent(value.trim())}`,controller.signal).then(result=>{
        if(controller.signal.aborted) return;
        setBrands(foodBrandSuggestions(result.brands,value));setError(result.error ?? null);
      }).catch(err=>{if(!controller.signal.aborted) setError(err instanceof Error ? err.message : 'Подсказки брендов недоступны');});
    },250);
    return ()=>{clearTimeout(timer);controller.abort();};
  },[value,focused]);
  const expanded=open && brands.length>0;
  useLayoutEffect(()=>{
    if(!expanded || active<0) return;
    const reveal=()=>{
      const list=listRef.current,option=list?.children[active] as HTMLElement | undefined;
      if(!list || !option) return;
      const row=option.getBoundingClientRect(),menu=list.getBoundingClientRect();
      if(row.top<menu.top+1) list.scrollTop-=menu.top+1-row.top;
      else if(row.bottom>menu.bottom-1) list.scrollTop+=row.bottom-menu.bottom+1;
      const bounds=option.getBoundingClientRect(),viewport=window.visualViewport;
      const top=(viewport?.offsetTop ?? 0)+8;
      const nav=document.querySelector<HTMLElement>('.nav');
      const navTop=nav && getComputedStyle(nav).display!=='none' ? nav.getBoundingClientRect().top : Infinity;
      const bottom=Math.min((viewport?.offsetTop ?? 0)+(viewport?.height ?? window.innerHeight),navTop)-8;
      if(bounds.bottom>bottom) window.scrollBy(0,bounds.bottom-bottom);
      else if(bounds.top<top) window.scrollBy(0,bounds.top-top);
    };
    reveal();window.visualViewport?.addEventListener('resize',reveal);
    return ()=>window.visualViewport?.removeEventListener('resize',reveal);
  },[active,expanded]);
  const choose=(brand:string)=>{onChange(brand);setOpen(false);setActive(-1);};
  return <div className="food-brand">
    <label className="fl" htmlFor={id}>Бренд <span className="mu">· необязательно</span></label>
    <input id={id} className="f" role="combobox" aria-autocomplete="list" aria-expanded={expanded} aria-controls={`${id}-list`} aria-activedescendant={expanded && active>=0 ? `${id}-${active}` : undefined}
      value={value} maxLength={80} placeholder="Например, Простоквашино"
      onChange={e=>{onChange(e.target.value);setOpen(true);}}
      onFocus={()=>{setFocused(true);setOpen(true);}} onBlur={()=>{setFocused(false);setOpen(false);}}
      onKeyDown={e=>{
        if(e.key==='Escape'){setOpen(false);setActive(-1);}
        if((e.key==='ArrowDown' || e.key==='ArrowUp') && brands.length){e.preventDefault();setOpen(true);setActive(i=>i<0 ? e.key==='ArrowDown' ? 0 : brands.length-1 : (i+(e.key==='ArrowDown'?1:-1)+brands.length)%brands.length);}
        if(e.key==='Enter' && expanded && active>=0){e.preventDefault();choose(brands[active]!);}
      }} />
    {expanded ? <ul ref={listRef} id={`${id}-list`} role="listbox" aria-label="Бренды" className="food-brand-list">{brands.map((brand,i)=><li key={brand} id={`${id}-${i}`} role="option" aria-selected={active===i} onPointerDown={e=>e.preventDefault()} onClick={()=>choose(brand)}>{brand}</li>)}</ul> : null}
    {error ? <p className="err" role="status">{error}</p> : null}
  </div>;
}
